import { FAQPage } from 'schema-dts';
import { jsonLdScriptProps } from 'react-schemaorg';
import Script from 'next/script';

import { LoyaltyLandingPageFAQViewModel } from '@api/v3';

export const FAQSchemaOrg = ({
  data,
}: {
  data: LoyaltyLandingPageFAQViewModel;
}) => {
  const subjects = data?.subjects;
  return (
    <Script
      defer
      {...jsonLdScriptProps<FAQPage>({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: subjects?.[0]?.items?.slice(0, 10).map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: { '@type': 'Answer', text: item.answer },
        })),
      })}
    />
  );
};
